import { render, staticRenderFns } from "./ParametricPagination.vue?vue&type=template&id=fc878f06"
import script from "./ParametricPagination.vue?vue&type=script&lang=js"
export * from "./ParametricPagination.vue?vue&type=script&lang=js"
import style0 from "./ParametricPagination.vue?vue&type=style&index=0&id=fc878f06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports